import { Controller } from "@hotwired/stimulus"

// Shows the text input when "Other (please specify)" is selected.
export default class extends Controller {
    static values = { label: String, multiple: Boolean }
    static targets = ["input", "select"]

    connect() { this.update() }
    update() {
        const sel = this.selectTarget
        const selected = this.multipleValue
            ? Array.from(sel.selectedOptions).map(o => o.text)
            : (sel.selectedOptions[0]?.text || "")
        const hasOther = this.multipleValue
            ? selected.includes("Other (please specify)")
            : selected === "Other (please specify)"
        this.inputTarget.classList.toggle("hidden", !hasOther)
    }
}
